import { type CountryCode, type ProjectCode } from '@constants'
import { useApiPopupCandidates } from '@hooks-api/fortune/useApiPopupCandidates'
import { useApiPopupExpiredCheck } from '@hooks-api/fortune/useApiPopupExpiredCheck'
import { useMemo, useRef } from 'react'

interface useUpdatePopupCandidatesProps {
  projectCode: ProjectCode
  campaignId?: number
  countryCode: CountryCode
}

export const useUpdatePopupCandidates = (props: useUpdatePopupCandidatesProps) => {
  const { projectCode, campaignId, countryCode } = props
  const hasRefetch = useRef(false)
  // 需給後端 ISO 格式，需再另外轉現在時區
  const lastUpdatedTime = useMemo(() => {
    const now = new Date()
    const offsetMs = now.getTimezoneOffset() * 60000
    return new Date(now.getTime() - offsetMs).toISOString().slice(0, -1)
  }, [])

  const {
    responseData: popupCandidates,
    mutate: refetchPopupCandidates,
  } = useApiPopupCandidates({
    country_code: countryCode,
    project_code: campaignId ? undefined : projectCode,
    campaign_id: campaignId,
  })

  // 如果 isExpired 為 true，則重新 fetch popupCandidates
  useApiPopupExpiredCheck({
    country_code: countryCode,
    project_code: campaignId ? undefined : projectCode,
    campaign_id: campaignId,
    last_updated_time: lastUpdatedTime,
  }, {
    onSuccess: (response) => {
      if (response?.data?.data && !hasRefetch.current) {
        hasRefetch.current = true
        refetchPopupCandidates()
      }
    },
  })

  return {
    popupCandidates,
  }
}
